import request from "@/utils/request.js";
import { YuliActivityOther } from "./config.js";
import _ from "lodash";

/**
 * 获取passcard列表
 * @param {*} params
 */
export const getPasscardlist = () => {
    return request.get(YuliActivityOther.getPasscardlist);
};